import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'bs-digital-result-succeeded-pick-list',
    template: `<ng-content />`,
    styleUrls: ['./result-succeeded-pick-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultSucceededPickListComponent {}
